import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HOWDENS_URL } from 'config';
import { selectors } from 'store';

export interface ExampleBannerHook {
  visible: boolean;
  returnUrl?: string;
}

export default function useExampleBanner(): ExampleBannerHook {
  const id = useSelector(selectors.document.getId);
  const job = useSelector(selectors.job.getEntity);
  const isIntroduced = useMemo(() => Boolean(job?.introduced_to), [job]);

  const visible = useMemo(() => {
    if (!id || !job) return false;
    const example = job?.flow_type === 'example';
    return example;
  }, [job, id]);

  const returnUrl = useMemo(() => {
    if (!id || !isIntroduced) return undefined;
    return `${HOWDENS_URL}/job/${id}`;
  }, [isIntroduced, id]);

  return {
    visible,
    returnUrl,
  };
}
